export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" fill="#FF3D8B" />
    <path transform="translate(8.3 36.5) scale(0.05 -0.05)" d="M436 21V9C436 -8 416 -15 365 -15C290 -16 172 -12 97 -4V-246C194 -254 300 -256 402 -256C603 -256 691 -191 755 -15L954 530H577L480 198H470L387 530H6L138 111C157 48 241 21 335 21Z" fill="#F0EEE9" />
    <rect x="8" y="53" width="48" height="4" fill="#1B1215" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center" aria-label="youth">
    <span
      className="wordmark text-pink text-[60px] sm:text-[78px] leading-[0.7] pb-[0.18em] inline-block transition-transform duration-500 group-hover:rotate-[-8deg]"
      data-testid="logo-wordmark"
    >
      y
    </span>
  </span>
);
